import { Component, OnInit, AfterContentInit } from '@angular/core';

import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RotinaService } from 'src/app/pages/cadastros/rotina/rotina.service';
import { AreaTecnicaService } from 'src/app/pages/cadastros/areatecnica/areatecnica.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { CommandResult } from '../../domain/commandResult';
import { validateConfig } from '@angular/router/src/config';
import { APP_SETTINGS, SCAMP_API } from 'src/environments/environment';
import { Arquivo, Rotina } from '../../domain/domain.model';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-rotina',
  templateUrl: './rotina.component.html',
  styleUrls: ['./rotina.component.scss'],
  providers: [RotinaService, AreaTecnicaService]
})
export class RotinaComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];
  public areasTecnicas: any[] = [];
  public areaTecnicaId = 0;
  public IdsPeriodicidade = [0, 0, 0, 0, 0];


  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isLoading = false;
  public isValidPeriodicidade = true;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;


  // Adicionar arquivos
  public files: File[] = [];
  public uriFileStringOrBase64 = ''; //  usado para exibir o arquivo ainda em memória
  public fileType = ''; // Informação do tipo de arquivo. P.ex: image ou pdf;
  public limiteUpload = APP_SETTINGS.tamanhoLimiteUploadArquivo;
  public arquivos: Arquivo[] = [];

  public classesRotinas = [1, 2, 3, 4, 5];

  public periodicidadesIndexes = [0, 1, 2, 3, 4, 5, 6];
  public periodicidadesStr = ["Dias (livre)", "Quinzenal", "Mensal", "Bimensal", "Trimestral", "Semestral", "Anual"];
  public periodicidadesValues = [0, 15, 30, 60, 90, 180, 365];
  public formEspacamentos = ["", "espacamentoOne", "espacamentoTwo", "espacamentoThree", "espacamentoFour", "espacamentoFive"]
  public formPeriodicidadeIndex = ["", "periodicidadeIndexOne", "periodicidadeIndexTwo", "periodicidadeIndexThree", "periodicidadeIndexFour", "periodicidadeIndexFive"]
  
  constructor(
    private rotinaService: RotinaService,
    private areaTecnicaService: AreaTecnicaService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService
  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('rotina');
  }

  ngOnInit() {
    this.getAreasTecnicas();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public changeAreaTecnica(areaTecnicaId: number) {

    this.areaTecnicaId = Number(areaTecnicaId);
    this.reset();
   

    if (this.areaTecnicaId === 0) {
      
      this.cadastrados = [];
      this.resetForm();
      
    } else {
      this.list();
    }


  }
  public list(): void {
    this.isLoading = true;
    this.rotinaService.list(this.areaTecnicaId).subscribe((response: any) => {
      this.cadastrados = response;
      this.setVoids();
      this.isLoading = false;

      this.form.controls.unidadeTempo.enable();
    });
  }

  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        codigo: new FormControl(null, [Validators.required]),
        unidadeTempo: new FormControl(null, [Validators.required, Validators.maxLength(2)]),
        instrucaoDeTrabalho: new FormControl(null, [Validators.required]),
        descricao: new FormControl(null, [Validators.required]),
        duracao: new FormControl(null, [Validators.required, Validators.max(9999)]),
        areaTecnicaId: new FormControl(null),
        espacamentoOne: new FormControl(null, [Validators.max(9999)]),
        espacamentoTwo: new FormControl(null, [Validators.max(9999)]),
        espacamentoThree: new FormControl(null, [Validators.max(9999)]),
        espacamentoFour: new FormControl(null, [Validators.max(9999)]),
        espacamentoFive: new FormControl(null, [Validators.max(9999)]),
        periodicidades: new FormControl([]),
        arquivos: new FormControl([]),
        periodicidadeIndexOne: new FormControl(0),
        periodicidadeIndexTwo: new FormControl(0),
        periodicidadeIndexThree: new FormControl(0),
        periodicidadeIndexFour: new FormControl(0),
        periodicidadeIndexFive: new FormControl(0),

      }
    );

    this.form.controls.unidadeTempo.disable();
    this.files = [];
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.isValidPeriodicidade = true;
    this.IdsPeriodicidade = [0, 0, 0, 0, 0];
    this.uriFileStringOrBase64 = '';
    this.arquivos = [];
    this.resetForm();
    
    this.resetSelectsPeriodicidade(0);
  }

  public getById(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.rotinaService.getById(id).subscribe(

      (response: any) => {


        this.form.get('id').setValue(response.id);
        this.form.get('codigo').setValue(response.codigo);
        this.form.get('descricao').setValue(response.descricao);
        this.form.get('duracao').setValue(response.duracao);
        this.form.get('unidadeTempo').setValue(response.unidadeTempo == null ? '' : response.unidadeTempo);
        this.form.get('instrucaoDeTrabalho').setValue(response.instrucaoDeTrabalho);

        this.form.controls.unidadeTempo.enable();

        const espacamentoOne = response.periodicidades.filter(t => t.classe === 1)[0];
        const espacamentoTwo = response.periodicidades.filter(t => t.classe === 2)[0];
        const espacamentoThree = response.periodicidades.filter(t => t.classe === 3)[0];
        const espacamentoFour = response.periodicidades.filter(t => t.classe === 4)[0];
        const espacamentoFive = response.periodicidades.filter(t => t.classe === 5)[0];


        this.form.get('espacamentoOne').setValue(espacamentoOne.espacamento);
        this.form.get('espacamentoTwo').setValue(espacamentoTwo.espacamento);
        this.form.get('espacamentoThree').setValue(espacamentoThree.espacamento);
        this.form.get('espacamentoFour').setValue(espacamentoFour.espacamento);
        this.form.get('espacamentoFive').setValue(espacamentoFive.espacamento);



        this.setSelectsPeriodicidade(0, espacamentoOne.espacamento);
        this.setSelectsPeriodicidade(1, espacamentoTwo.espacamento);
        this.setSelectsPeriodicidade(2, espacamentoThree.espacamento);
        this.setSelectsPeriodicidade(3, espacamentoFour.espacamento);
        this.setSelectsPeriodicidade(4, espacamentoFive.espacamento);
        

        this.IdsPeriodicidade[0] = espacamentoOne.id;
        this.IdsPeriodicidade[1] = espacamentoTwo.id;
        this.IdsPeriodicidade[2] = espacamentoThree.id;
        this.IdsPeriodicidade[3] = espacamentoFour.id;
        this.IdsPeriodicidade[4] = espacamentoFive.id;

        this.arquivos = response.arquivos;

        this.isEditing = true;
        this.isProcessing = false;
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false
    );
  }

  public getAreasTecnicas() {
    this.areaTecnicaService.getAreasTecnicas().subscribe(response => this.areasTecnicas = response);
  }

  public submit(): void {

    if (this.validForm()) {

      this.isProcessing = true;

      if (this.isEditing === false) {

        this.rotinaService.isUniqueCodigoRotina(this.form.get('codigo').value).subscribe(

          (isUniqueCodigoRotina: boolean) => {

            if (isUniqueCodigoRotina) {
              this.save();
            } else {
              this.form.get('codigo').setErrors({ isNotUniqueCodigo: true });
              this.isProcessing = false;
            }

          },
          (exception: any) => {
            this.showErrorExecption(exception);
            this.isProcessing = false
          },
          () => this.isProcessing = false
        );

      } else {
        this.save();
      }
    }
  }

  public validForm() {

    this.isValidPeriodicidade = true;

    if (Number(this.form.get('espacamentoTwo').value) < Number(this.form.get('espacamentoOne').value)) {
      this.isValidPeriodicidade = false;
      this.form.get('espacamentoTwo').setErrors({ invalid: true });
    }

    if (Number(this.form.get('espacamentoThree').value) < Number(this.form.get('espacamentoTwo').value)) {
      this.isValidPeriodicidade = false;
      this.form.get('espacamentoThree').setErrors({ invalid: true });
    }

    if (Number(this.form.get('espacamentoFour').value) < Number(this.form.get('espacamentoThree').value)) {
      this.isValidPeriodicidade = false;
      this.form.get('espacamentoFour').setErrors({ invalid: true });
    }

    if (Number(this.form.get('espacamentoFive').value) < Number(this.form.get('espacamentoFour').value)) {
      this.isValidPeriodicidade = false;
      this.form.get('espacamentoFive').setErrors({ invalid: true });
    }

    if (Number(this.form.get('duracao').value) > 9999) {
      this.form.get('duracao').setErrors({ invalid: true });
      return false;
    }

    return this.isValidPeriodicidade;
  }

  public save() {

    const periodicidades: any[] = [];

    periodicidades.push({ id: this.IdsPeriodicidade[0], classe: 1, espacamento: this.form.get('espacamentoOne').value });
    periodicidades.push({ id: this.IdsPeriodicidade[1], classe: 2, espacamento: this.form.get('espacamentoTwo').value });
    periodicidades.push({ id: this.IdsPeriodicidade[2], classe: 3, espacamento: this.form.get('espacamentoThree').value });
    periodicidades.push({ id: this.IdsPeriodicidade[3], classe: 4, espacamento: this.form.get('espacamentoFour').value });
    periodicidades.push({ id: this.IdsPeriodicidade[4], classe: 5, espacamento: this.form.get('espacamentoFive').value });

    this.form.get('periodicidades').setValue(periodicidades);
    this.form.get('areaTecnicaId').setValue(this.areaTecnicaId);

    this.form.get('arquivos').setValue(this.arquivos);

    this.form.controls.unidadeTempo.enable();
    this.rotinaService.post(this.form.value, this.arquivos.filter(t => t.id <= 0), this.files).subscribe(

      (response: CommandResult) => {

        if (response.success === true) {
          this.toastr.success(response.message);
          this.list();
          this.reset();
        } else {
          this.toastr.error(response.message);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.rotinaService.delete(id).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }


  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
    if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }
    this.toastr.error(`<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`);
  }

  

  handleFiles(fileInputs: File[]) {

    if (fileInputs.length === 0) { return; }

    let fileAlreadyAddedInMemory = false;
    let fileAlreadyAddSaved = false;

    let msgErroArquivo = '';
    let qtdErrosArquivo = 0;
    
    let arquivoValido = true;

    Array.from<File>(fileInputs).forEach(fileInput => {

      const tamanhoArquivo = Number((fileInput.size / 1024 / 1024).toFixed(2));

      if (tamanhoArquivo <= this.limiteUpload) {
        if (fileInput.name.length > 100)
        {
          arquivoValido = false;
          qtdErrosArquivo++;
          msgErroArquivo += `${fileInput.name} - [${fileInput.name.length} caracteres] <br />`;
          msgErroArquivo = `O nome do arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir é muito longo e não foi adicionado`;
  
        } else {
          arquivoValido = true;
        }
      } else {
        arquivoValido = false;
        qtdErrosArquivo++;
        msgErroArquivo += `${fileInput.name}  [${tamanhoArquivo}MB] <br />`;
        msgErroArquivo = `O arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir ultrapassa o limite de `;
        msgErroArquivo += `<span class="fb">${this.limiteUpload} MB</span> permito para uploads e não foi adicionado.`;
      }

      if (arquivoValido) {

        
        // verifica pelo nome do arquivo se ele já foi adicionado em memória ou já inserido na lista de arquivos
        fileAlreadyAddedInMemory = this.files.find(t => t.name === fileInput.name) !== undefined;
        
        fileAlreadyAddSaved = this.arquivos.find(t => t.nomeOriginal === fileInput.name ) !== undefined;
        



        if (!fileAlreadyAddedInMemory && !fileAlreadyAddSaved) {
          // adiciona em memória o arquivo ainda não adicionado
          this.files.push(fileInput); // adiciona na lista de arquivos
          let proxId = this.getProxIdNegativo(this.arquivos); // Novos arquivos recebem Id negativos
          
          // adicionar um novo objeto arquivo na coleção de arquivos
          this.arquivos.push({
            id: proxId,
            nomeOriginal: fileInput.name,
            nome: '',
            rotinaId: 0
          });
          
        }

        (document.getElementById('fileInput') as HTMLInputElement).value = '';
        // observação: necessário para limpar o fileInput e permitir reenserir um mesmo item que acabou de remover. 

      }
    });

    if (qtdErrosArquivo > 0) {

     Swal({
      position: 'center',
      html: msgErroArquivo,
      type: null,
      animation: false,
      customClass: 'animated fadeInDown',
      width: '550px',
      heightAuto: false,
      background: '#f7b924',
      showCloseButton: true,
      showConfirmButton: false,
    });

    }

  }


  showFile(nome: string, nomeOriginal: string, modal: any) {

    let fileName = nome;
    if (fileName == '') {
      fileName = nomeOriginal;
    }

    this.uriFileStringOrBase64 = '';
    const file = Array.from<File>(this.files).find(t => t.name === fileName);
    if (file !== undefined) {
      // trata os arquivos em memória, aqueles adicionados e ainda não persistidos
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.uriFileStringOrBase64 = event.target.result;
        this.fileType = this.getFileType(file.type);
        if (this.fileType === 'image' || this.fileType === 'pdf') {
          this.modalService.open(modal, { windowClass: 'showFile', backdrop: 'static' });
        }
      };
      reader.readAsDataURL(file);
    } else {
     
      // trata os arquivos já persisitidos, cujas informações vieram do banco ao selecionar um Chamado para edição
      const mgu = this.arquivos.find(t => t.nome === fileName);
      if (mgu !== undefined) {
        // obtem o tipo de arquivo para abrir o visualizador adequado ou baixar se não houver um correspondente
        // a aplicação possui um visualizador de pdf e outro de imagens para os demais tipos será feito o download
        this.fileType = this.getFileTypeByFileName(mgu.nome);
        this.uriFileStringOrBase64 = `${SCAMP_API.pathUploadFiles}/${mgu.nome}`
       
        if (this.fileType === 'image' || this.fileType === 'pdf') {
          this.modalService.open(modal, { windowClass: 'showFile', backdrop: 'static' });
        }
      }
    }

  }

  private getFileType(type: string): string {
    if (type.split('/')[0] === 'image') {
      return 'image';
    } else if (type.split('/')[1] === 'pdf') {
      return 'pdf';
    } else {
      return 'diverso';
    }
  }

  private getFileTypeByFileName(arquivoNome: string): string {
    const nameParts = arquivoNome.split('.');
    const extension = nameParts[nameParts.length - 1];

    if (extension.toLowerCase() === 'pdf') {
      return 'pdf';
    } else if (extension.toLowerCase() === 'jpg' || extension.toLowerCase() === 'jpeg'
      || extension.toLowerCase() === 'png' || extension.toLowerCase() === 'gif') {
      return 'image';
    } else {
      return 'diverso';
    }
  }

  removeArquivo(arquivo: Arquivo) {

    if (arquivo.id > 0) {

      Swal({
        title: '',
        html: `<b>Atenção</b><br />
        <small>O arquivo físico será removido permanentemente e a ação<br />não poderá ser desfeita</small>
            <br /><br />Deseja remover o arquivo<br />
            <b>${arquivo.nome}</b>?`,
        type: 'question',
        showCancelButton: true,
        cancelButtonText: 'Não',
        showConfirmButton: true,
        confirmButtonText: 'Sim',
        cancelButtonColor: '#d33',
        focusCancel: true,
        animation: false,
        customClass: 'animated fadeInDown',
        width: '450px'
      }).then((result) => {
        if (result.value) {

          this.rotinaService.removeFile(arquivo.id, arquivo.nome).subscribe(

            (response: CommandResult) => {

              if (response.success === true) {
                this.toastr.success(response.message);
                this.removeFileOfMemory(arquivo.id);
              } else {
                this.toastr.error(response.message);
              }
            },
            (exception: any) => {
              this.showErrorExecption(exception);
            },
          );
        }
      });
    } else {
      // arquivo ainda não persistido, remove-o da memória
      this.removeFileOfMemory(arquivo.id);
    }
  }

  removeFileOfMemory(id: number) {
    const mgu = this.arquivos.find(t => t.id === Number(id));
    if (mgu !== undefined) {
      // remove o arquivo armazenado em files
      this.files = Array.from<File>(this.files).filter(f => f.name !== mgu.nomeOriginal);
      // remove item de chamadoUploads armazenado em memória
      this.arquivos =
        this.arquivos.filter(t => t.id !== Number(id));
    }
  }


  getProxIdNegativo(list: any[])
  {
    
    let ids = list.map(x => Math.abs(x.id));

    if (ids != undefined) {

      const maiorId = ids.reduce((acumulador, valor) => acumulador < valor ? valor : acumulador, 0 );
      return (maiorId + 1) * -1;
    }
    else 
    {
      return -1;
    }

  }

  changePeriodicidade(index: number, classe: number) {
    this.form.get(this.formEspacamentos[classe]).setValue('');
    this.form.get(this.formPeriodicidadeIndex[classe]).setValue(0);

    if (index > 0) {
      this.form.get(this.formEspacamentos[classe]).setValue(this.periodicidadesValues[index]);
      this.form.get(this.formPeriodicidadeIndex[classe]).setValue(index);
    } 
  }

  setAllSamePeriodicidade(index: number) {
    this.classesRotinas.forEach( x =>  this.changePeriodicidade(index, x));
    this.resetSelectsPeriodicidade(index);
  }

  resetSelectsPeriodicidade(index) {
    const selects = document.getElementsByClassName('selectPeriodicidade');
    Array.from(selects).forEach(x => (x as HTMLSelectElement).value = String(index))
  }

  setSelectsPeriodicidade(classe, espacamento) {
    const selects = document.getElementsByClassName('selectPeriodicidade');
    let indexPeriodicidade = this.periodicidadesValues.indexOf(espacamento);

    if (indexPeriodicidade < 0) indexPeriodicidade = 0;

    (selects[classe] as HTMLSelectElement).value = String(indexPeriodicidade);
    this.form.get(this.formPeriodicidadeIndex[(classe + 1)]).setValue(indexPeriodicidade);
  }



}
